<template>
  <footer class="start-footer">
    <main class="start-footer__content">
      <section
        v-for="item in items"
        :key="item.label"
        class="start-footer__column"
      >
        <div v-for="child in item.children" :key="child.label">
          <a
            v-if="child.href"
            :href="child.href"
            :target="child.target"
            class="start-footer__link"
          >
            <v-icon class="start-footer__link-icon" size="15">{{ child.icon }}</v-icon>
            <span>{{ child.label }}</span>
          </a>

          <button v-if="child.command" class="start-footer__link" @click="child.command">
            <v-icon class="start-footer__link-icon" size="15">{{ child.icon }}</v-icon>
            <span>{{ child.label }}</span>
          </button>
        </div>
      </section>
      
      <AppLogoButton class="start-footer__logo-button mx-auto" />
    </main>
  </footer>
</template>

<script>
import AppLogoButton from '../Common/AppLogoButton.vue';

export default {
  name: 'LoggedOutFooter',
  
  components: {
    AppLogoButton
  },

  computed: {
    items() {
      return [
        {
          children: [
            {
              href: 'https://www.byggbranschensyrkesnamnd.se/wp-content/uploads/2026/07/Manual-Mina-Sidor.docx',
              icon: '$sl-manual',
              label: this.$t('menu.manual'),
              target: '_blank'
            },
            {
              href: 'https://www.byggbranschensyrkesnamnd.se/faq/',
              icon: '$sl-question',
              label: this.$t('menu.faq'),
              target: '_blank'
            },
            {
              href: 'mailto:support@byn.se',
              icon: '$sl-forum',
              label: this.$t('menu.contact-support'),
              target: '_blank'
            }
          ]
        },
        {
          children: [
            {
              command: () => this.showLinks(),
              icon: '$sl-file-document',
              label: this.$t('labels.document'),
              target: '_blank'
            }
          ]
        },
        {
          children: [
            {
              href: 'https://www.byggbranschensyrkesnamnd.se/kontakt/',
              icon: '$sl-email-outlined',
              label: this.$t('company.contact'),
              target: '_blank'
            }
          ]
        }
      ]
    }
  },

  methods: {
    showLinks() {
      this.$emit('show-links')
    }
  }
}
</script>

<style lang="scss" scoped>
.start-footer {
  padding: 16px 24px;
  background-color: $color-inverse-primary;

  &__content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    align-items: center;
    gap: 32px;
  }

  &__column {
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-self: center;
    gap: 8px;

    p {
      font-size: 12px !important;
    }

    &-title {
      font-weight: 600 !important;
    }
  }

  &__link {
    width: fit-content;
    margin: 0 auto;
    color: $color-text-dark !important;
    font-weight: normal !important;
    font-size: 14px !important;
    line-height: 16px !important;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  @media (max-width: 768px) {
    &__content {
      grid-template-columns: 1fr;
    }
  }

  @media (min-width: 768px) {
    &__column {
      &:first-of-type {
        justify-self: start;
        text-align: left;

        .start-footer__link {
          margin: unset !important;
        }
      }

      &:last-of-type {
        justify-self: end;
        text-align: right;
      }
    }

    &__logo-button {
      display: none;
    }
  }
}
</style>